import { ApolloProvider } from "@apollo/client/react";
import { client } from "../lib/apollo";
import { useQuery } from "@apollo/client";
import { GET_CATEGORY_POSTS } from '../queries/queries';
import Image from "next/legacy/image";
import { formatPostDate } from "../utilities/dateFormat";
import { useRouter } from 'next/router';

let initialLoad = true;

// Function to update the query with the new results
const updateQuery = (previousResult, { fetchMoreResult }) => {
  initialLoad = false;

  window.scrollTo(0, 0);
  return fetchMoreResult.categories?.edges[0]?.node?.posts?.edges?.length ? fetchMoreResult : previousResult;
};

// Component that shoes the paginated list of posts
const PostList = ({ data, error, loading, fetchMore, category, newsList }) => {
  const posts  = initialLoad ? newsList.data.categories?.edges[0]?.node?.posts : data?.categories?.edges[0]?.node?.posts;

  return (
    <div>
      {posts && posts.edges ? (
        <>
       <div id="news-list-container" className='container'>
        {
          posts.edges.map( ( item, index ) => {
            return <div className="news-list-item" key={ 'news-' + item.node.databaseId + '-' + index }>
                <div>
                  <a aria-label={`${item.node.title}`} href={`${item.node.uri}`}>
                    {
                      item?.node.featuredImage?.node && (
                        <Image
                          src={`${item.node.featuredImage?.node.sourceUrl}`}
                          srcSet={item.node.featuredImage?.node.mediaDetails?.srcSet}
                          sizes={item.node.featuredImage?.node.mediaDetails?.sizes}
                          height={
                            340
                          }
                          quality={100}
                          width={530}
                          alt={item.node.featuredImage?.node.altText}
                          title={item.node.featuredImage?.node.title}
                        />
                      )
                    }
                  </a>
                </div>
                <div>
                  <h4 dangerouslySetInnerHTML={{__html: item.node.title}}></h4>
                  <div className="news-list-details">
                    <p>{formatPostDate(item.node.date)}</p>
                  </div>
                  {
                      item.node?.searchExcerpt?.excerpt && (
                          <div dangerouslySetInnerHTML={{__html: item.node.searchExcerpt.excerpt}}></div>
                      )
                  }
                  {
                      !item.node?.searchExcerpt?.excerpt && item.node.excerpt && (
                        <div dangerouslySetInnerHTML={{__html: item.node.excerpt}}></div>
                    )
                  }
                  <a aria-label={`${item.node.title}`} href={`${item.node.uri}`} className="button red">
                    continue reading
                  </a>
                </div>
            </div>
          })
        }
      </div>
      {
        (posts.pageInfo.hasPreviousPage || posts.pageInfo.hasNextPage) && (
          <div id="news-list-pagination" className="container">
            <div className="container">
              <div>
              {posts.pageInfo.hasPreviousPage ? (
                  <div>
                    <button
                      onClick={() => {
                        fetchMore({
                          variables: {
                            first: null,
                            after: null,
                            last: 8,
                            before: posts.pageInfo.startCursor || null,
                            category: category
                          },
                          updateQuery
                        });
                      }}
                    >
                      previous
                    </button>
                  </div>
                ) : <div></div>}
                {posts.pageInfo.hasNextPage ? (
                  <div>
                    <button
                      onClick={() => {
                        fetchMore({
                          variables: {
                            first: 8,
                            after: posts.pageInfo.endCursor || null,
                            last: null,
                            before: null,
                            category: category
                          },
                          updateQuery
                        });
                      }}
                    >
                      next
                    </button>
                  </div>
                ) : <div></div>}
              </div>
            </div>
          </div>
        )
      }
      </>
      ) : (
        <div>No news was found...</div>
      )}
    </div>
  );
};

const Posts = (postData) => {
  const router = useRouter();
  const category = router.query.uri;

  const variables = {
    first: 8,
    last: null,
    after: null,
    before: null,
    category: category
  };
  const { data, error, loading, fetchMore } = useQuery(GET_CATEGORY_POSTS, {
    variables
  });

  if (error) {
    return <pre>{JSON.stringify(error)}</pre>;
  }

  if (loading) {
    return null;
  }

  return (
    <PostList
      error={error}
      loading={loading}
      data={data}
      category = {category}
      fetchMore={fetchMore}
      newsList={postData.newsList}
    />
  );
};

export default ({newsList}) => {
  return (
    <ApolloProvider client={client}>
      <Posts newsList={newsList} />
    </ApolloProvider>
  )
}